<template>
  <div>
    {{ "Deleted component, do not use" }}
  </div>
</template>

<script>
export default {
  name: "b2b-footer",
};
</script>
